import { FunctionField, useLocaleState } from "react-admin";
import { countries } from "shared/src/constants/countries";

export const CountryField = (props) => {
    const [locale] = useLocaleState();
    return (
        <FunctionField
            {...props}
            source="address.country"
            render={(record) =>
                countries.find(
                    (country) => country.id === record.address.country
                )?.name[locale]
            }
        />
    );
};
